import { useEffect, useState } from 'react';
import { Star, ArrowRight } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';
import { api } from '../App';

export default function Testimonials() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get('/settings/testimonials').then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section id="reviews" data-testid="testimonials-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal className="text-center">
          <Eyebrow>Client Words</Eyebrow>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
            Businesses that <span className="text-gradient-gold">stopped chasing leads.</span>
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((q, i) => (
            <Reveal key={q.id} i={i + 1}>
              <figure className="h-full bg-[#0F1C33]/60 border border-slate-700/40 hover:border-amber-500/30 rounded-2xl p-8 transition-colors duration-500 flex flex-col">
                <div className="flex gap-1 mb-5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={15} className="text-amber-400 fill-amber-400" />
                  ))}
                </div>
                <blockquote className="text-slate-300 text-sm leading-relaxed flex-1">“{q.quote}”</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-slate-800">
                  <div className="font-display font-semibold text-sm">{q.name}</div>
                  {q.detail && <div className="font-mono-tech text-[10px] tracking-[0.2em] text-slate-500 uppercase mt-1">{q.detail}</div>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal i={4} className="mt-10 text-center">
          <a
            href="/review"
            data-testid="testimonials-review-link"
            className="inline-flex items-center gap-2 text-sm text-amber-300 hover:text-amber-200 transition-colors"
          >
            Worked with us? Leave a Google review <ArrowRight size={15} />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
